// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  padding: 30px;
  max-width: 500px;
  width: 90%;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #666;
  line-height: 1;
}

.modal-close:hover {
  color: #000;
}

.modal-content h2 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #333;
}

.verification-subtitle {
  color: #666;
  margin-bottom: 20px;
  font-size: 14px;
}

.expiration-time {
  color: #e74c3c;
  font-size: 13px;
  margin-bottom: 20px;
  font-weight: 500;
}

.expiration-time.expired {
  color: #c0392b;
  font-weight: 600;
}

.code-input-group {
  margin-bottom: 20px;
}

.code-input-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.code-input {
  width: 100%;
  padding: 12px;
  font-size: 24px;
  text-align: center;
  letter-spacing: 8px;
  border: 2px solid #ddd;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
}

.code-input:focus {
  outline: none;
  border-color: #007bff;
}

.error-message {
  color: #e74c3c;
  font-size: 14px;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #fee;
  border-radius: 4px;
}

.verify-button {
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.verify-button:hover:not(:disabled) {
  background-color: #0056b3;
}

.verify-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.resend-section {
  margin-top: 20px;
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.resend-section p {
  margin-bottom: 10px;
  color: #666;
  font-size: 14px;
}

.resend-button {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
}

.resend-button:hover:not(:disabled) {
  color: #0056b3;
}

.resend-button:disabled {
  color: #ccc;
  cursor: not-allowed;
}

`, "",{"version":3,"sources":["webpack://./src/components/EmailVerificationModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  padding: 30px;\n  max-width: 500px;\n  width: 90%;\n  position: relative;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n.modal-close {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #666;\n  line-height: 1;\n}\n\n.modal-close:hover {\n  color: #000;\n}\n\n.modal-content h2 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.verification-subtitle {\n  color: #666;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.expiration-time {\n  color: #e74c3c;\n  font-size: 13px;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.expiration-time.expired {\n  color: #c0392b;\n  font-weight: 600;\n}\n\n.code-input-group {\n  margin-bottom: 20px;\n}\n\n.code-input-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n}\n\n.code-input {\n  width: 100%;\n  padding: 12px;\n  font-size: 24px;\n  text-align: center;\n  letter-spacing: 8px;\n  border: 2px solid #ddd;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n}\n\n.code-input:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.error-message {\n  color: #e74c3c;\n  font-size: 14px;\n  margin-bottom: 15px;\n  padding: 10px;\n  background-color: #fee;\n  border-radius: 4px;\n}\n\n.verify-button {\n  width: 100%;\n  padding: 12px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.verify-button:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.verify-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.resend-section {\n  margin-top: 20px;\n  text-align: center;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.resend-section p {\n  margin-bottom: 10px;\n  color: #666;\n  font-size: 14px;\n}\n\n.resend-button {\n  background: none;\n  border: none;\n  color: #007bff;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: 14px;\n}\n\n.resend-button:hover:not(:disabled) {\n  color: #0056b3;\n}\n\n.resend-button:disabled {\n  color: #ccc;\n  cursor: not-allowed;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
